import React, { useCallback } from "react";

import { TABLE_HEADER_PATIENT } from "constants/dashboard";
import { icons } from "constants/icons";
import cn from "classnames";
import {
  FILTER_KEYS,
  FilterParams,
  SortConfig,
  SortDirection,
} from "types/common";
import { FilterDropdown } from "components/FilterDropdown/FilterDropdown";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { selectJointFilterParams } from "store/PatientRegionsStore/selectors";
import { changeJointFilterParams } from "store/PatientRegionsStore/actions";

type Props = {
  onClick: (sortBy: string) => void;
  sortConfig: SortConfig;
};
export const PatientTableHeader = ({ onClick, sortConfig }: Props) => {
  const jointFilterParams = useAppSelector(selectJointFilterParams);
  const dispatch = useAppDispatch();

  const onApplyRegionFilters = useCallback(
    (filterKey: FILTER_KEYS, filterParams: FilterParams[]) => {
      dispatch(changeJointFilterParams(filterParams));
    },
    [dispatch]
  );

  const onResetRegionFilters = useCallback(
    (filterKey: FILTER_KEYS, filterParams: FilterParams[]) => {
      dispatch(changeJointFilterParams(filterParams));
    },
    [dispatch]
  );
  return (
    <div>
      <div className="w-full flex items-center text-grayDark text-[10px] px-3 mb-2.5 ">
        {TABLE_HEADER_PATIENT.map((item: any) => {
          const handleClick = () => {
            onClick(item.title);
          };
          return (
            <div
              key={item.title}
              className="space-x-1 text-left  relative"
              style={{ width: item.width }}
            >
              {item.title && (
                <button
                  type="button"
                  onClick={handleClick}
                  className=" flex items-center space-x-2"
                >
                  <strong>{item.title}</strong>
                  <img
                    src={icons.carrotDown}
                    alt="arrow"
                    className={cn("transition-all mt-[0.5px]", {
                      "rotate-180":
                        sortConfig.sortBy === item.title &&
                        sortConfig.sortDirection === SortDirection.asc,
                    })}
                  />
                </button>
              )}

              {item?.filterKey && (
                <div className="absolute right-0 top-[-4px] ">
                  <FilterDropdown
                    title="Regions"
                    filterKey={item.filterKey}
                    filterParams={jointFilterParams}
                    onApply={onApplyRegionFilters}
                    onReset={onResetRegionFilters}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
